import { Button } from "@circleco/compass/components/Button";
import { TextInput } from "@circleco/compass/components/TextInput";
import { Typography } from "@circleco/compass/components/Typography";
import { useLayoutEffect, useRef, useState } from "react";

import { t } from "@/i18n-js/instance";

import { useCustomIconUpload } from "../../hooks/useCustomIconUpload";
import { useLinkImageUpload } from "../../hooks/useLinkImageUpload";

interface LinkUploaderProps {
  close: () => void;
}

export const LinkUploader = ({ close }: LinkUploaderProps) => {
  const [imageUrl, setImageUrl] = useState("");
  const fileLinkInputRef = useRef<HTMLInputElement>(null);

  const { uploadFile, isUploading, isError, response } = useCustomIconUpload({
    close,
  });
  const { fetchAndUpload, imageError, isProcessing } = useLinkImageUpload({
    uploadFile,
  });

  useLayoutEffect(() => {
    fileLinkInputRef.current?.focus();
  }, []);

  let ctaLabel = t("emoji_picker_v3.custom_icon.cta");
  if (isUploading) {
    ctaLabel = t("emoji_picker_v3.custom_icon.cta_uploading");
  } else if (isProcessing) {
    ctaLabel = t("emoji_picker_v3.custom_icon.link_upload.cta_processing");
  }

  return (
    <div className="flex flex-col gap-2">
      <div className="flex w-full gap-2">
        <TextInput
          ref={fileLinkInputRef}
          value={imageUrl}
          placeholder={t("emoji_picker_v3.custom_icon.link_upload.placeholder")}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setImageUrl(e.target.value)
          }
        />
        <Button
          variant="outline"
          type="button"
          disabled={!imageUrl || isUploading || isProcessing}
          onClick={() => fetchAndUpload(imageUrl)}
        >
          {ctaLabel}
        </Button>
      </div>
      {(imageError || isError) && (
        <Typography variant="label-xs" color="danger">
          {imageError}
          {isError && response?.errors?.[0]?.detail}
        </Typography>
      )}
    </div>
  );
};
